<template>
    <div class="performance-mPan">
        <m-search-list
        ref="searchList"
        :searchId="searchId"
        :list="config.searchList"
        :searchTotalTitle="config.searchTotalTitle"
        :initSearchInfo="initSearchInfo"
        :popPrefix="popPrefix"
        :configurationUrl="configurationUrl"
        :longPrefix="longPrefix"
        :advancePrefix="advancePrefix"
        :searchSetTitle="searchSetTitle"
        :pickerConfig="pickerConfig"
        @search-list-change="searchListChange"
        @onSearchChange="searchChange"
        >
            <span slot="search-list-advance-right">
                <slot name="search-list-advance-right"></slot>
            </span>
            <div slot="table-module-btn" class="btn-box">
                <reportExport
                    #default="{ submit }"
                    reportCode="TMS_TRANSPORT_MONITOR_REPORT"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span class="mgl-10 bigData-btn-export">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
                <slot name="table-module-btn"></slot>
                <el-tooltip v-if="config.configuration ? false : true"
                class="item allocation-box" effect="dark"
                :content="$translate('component.E202007310002', { defaultText: '列配置' })" placement="bottom">
                    <el-button size="mini" class="el-icon-setting" @click="openColumnConfig"></el-button>
                </el-tooltip>
                <el-dialog :visible.sync="showModal"
                    :close-on-click-modal="config.configurationCloseOnClickModal || false"
                    :close-on-press-escape="config.configurationCloseOnPressEscape || false"
                    :title="$translate('component.E202007310002', { defaultText: '列配置' })"
                    >
                    <configuration
                    ref="dialog"
                    :checkedList="checkedList"
                    :selectAllColumns="config.table.columns"
                    :columnNum='columnNum'
                    @getTableConfigList="setColumnConfig"
                    @tableConfigClose="closeColumnConfig"
                    ></configuration>
                </el-dialog>
            </div>
        </m-search-list>
    </div>
</template>
<script>
import mSearchList from '@/components/otpPanel/mSearchList';
import configuration from '@/components/otpPanel/configuration-list';
import reportExport from '@/components/lots/reportExportPlugin';
import { I18nMixins } from '@/components/utils/i18n';
import { getList } from '@/components/otpPanel/api.js';
import { mapGetters } from 'vuex';
import { getConfigParams, findMenuResourceCode } from './util.js';
export default {
    name: 'performanceMSearchList',
    components: { mSearchList, configuration, reportExport },
    mixins: [I18nMixins],
    props: {
        searchId: String,
        config: {
            type: Object,
            default() { return {}; }
        },
        searchSetTitle: {
            type: Array,
            default() { return []; }
        },
        initSearchInfo: {
            type: Object,
            default() { return {}; }
        },
        pickerConfig: {
            type: [Object, String],
            default: ''
        },
        columnNum: Number
    },
    computed: {
        ...mapGetters(['menus', 'user'])
    },
    data() {
        return {
            pageID: 'columnsConfig',
            popPrefix: this.config.popPrefix || '/api-mdm/dictionaryDetail/dict',
            configurationUrl: this.config.configurationUrl || '/api-auth',
            longPrefix: this.config.longPrefix || '/api-gwms/es/comboBox',
            advancePrefix: this.config.advancePrefix || '/api-mdm',
            showModal: false, // 是否显示列配置弹窗
            checkedList: '', // 列配置label集合字符串
            moduleCode: '' // 当前模块编码
        };
    },
    mounted() {
        this.getColumnConfigList();
    },
    methods: {
        /**
         * @description 获取列配置label列表
         */
        getColumnConfigList() {
            const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
            this.moduleCode = findMenuResourceCode(this, menu); // 找到当前模块资源编码
            const params = getConfigParams(this); // 获取设置列配置参数
            params.moduleCode = this.moduleCode;
            getList.get(this.configurationUrl, params).then(res => {
                if (res && +res.code === 0) {
                    this.checkedList = res.data.configNameCn;
                } else {
                    this.checkedList = this.config.table.initTableLabels ? this.config.table.initTableLabels : params.configNameCn;
                }
                this.$emit('tableConfigChange', this.checkedList);
            });
        },

        /**
         * @description 列配置弹窗配置
         * @param {String} configNameCn 调整后的列配置字段中文名称
         * @param {String} configName 调整后的列配置字段英文名称
         */
        setColumnConfig(configNameCn, configName) {
            const pramas = {
                configName,
                configNameCn,
                subjectType: this.pageID, // 项目类型
                moduleCode: this.moduleCode, // 当前菜单模块编码
                id: this.user.employeeId // id属性为本地缓存使用，非接口属性
            };
            getList.post(this.configurationUrl, pramas).then(res => {
                if (res && +res.code === 0) {
                    this.showModal = false;
                    this.$emit('tableConfigChange', configNameCn);
                }
            });
        },

        // 导出
        exportFile(submit) {
            this.$emit('export', submit);
        },

        searchListChange(config, data) {
            this.$emit('search-list-change', config, data);
        },

        // 查询
        searchChange(data) {
            this.$emit('searchChange', data);
        },

        // 打开列配置弹窗
        openColumnConfig() {
            this.showModal = true;
        },

        // 关闭列配置弹窗
        closeColumnConfig() {
            this.showModal = false;
        }
    }
};
</script>
<style scoped>
.btn-box {
    text-align: right;
}
.allocation-box {
    margin-left: 10px;
}
</style>
